import {
  faDownload,
  faMinus,
  faPlus,
  faTrash,
  faXmark,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormHelperText, Input, Option, Select, Textarea } from "@mui/joy";
import { FormControlLabel, Switch, Tooltip, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Modal,
  ModalBody,
  ModalFooter,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { Button, Form } from "reactstrap";
import { formatAmount } from "../../components/Common";
import SideBar from "../../components/sidebar/Sidebar";
import UserBase from "../../components/user/UserBase";
import "../../css/formPOPup.css";
import "../../css/myestare.css";
import {
  cryptoAssests,
  deleteCryptoAssest,
  getCryptoAssests,
  updateCryptoNetWorthStatus,
  updateCryptoPublicStatus,
  updateDocumentApi
} from "../../services/CryptoService";
import {
  deleteSingleProperty,
  downloadDocument1,
  fetchNetWorth,
  getBeneficiary,
  getOwnerByUserId,
  getSecondaryUser,
  getToken,
  getTrustByUserId,
  getUser,
} from "../../services/user-service";
import { ConfirmationPopup } from "./ConfirmationPopup";
import Deletebutton from "./Deletebutton";
import UpdateButton from "./UpdateButton";
import SharedBeneficiary from "../../components/SharedBeneficiary";
import { getCachedBitcoinPrice } from "./cryptoPrice";
import { getCachedEthereumPrice } from "./EthereumPrice";
const getInitialCryptoData = () => ({
  cryptoAssest: {
    cryptoListName: "",
    owner: "",
    heading: "",
    coin: "Bitcoin",
    storageType: "",
    exchangeOrWallet: "",
    otherExchangeOrWallet: "",
    quantity: "",
    notes: "",
    estValue: "",
    isPartOfNetWorth: "true",
    trust: "",
    isPublic: "false",
  },
  sharedDetails: [
    {
      distributedType: "",
      distributedValue: "",
      distributedAmount: "",
      beneficiaryId: "",
    },
  ],
});

function Crypto() {
  const [cryptoAssetData, setCryptoAssetData] = useState([
    getInitialCryptoData(),
  ]);
  const [errors, setErrors] = useState({
    cryptoValueData: [],
  });
  const [files, setFiles] = useState([]);

  const [modal, setModal] = useState(false);
  const [cryptoListNameValue, setCryptoListNameValue] = useState("");
  const handleChangeAddCryptoListName = (event) => {
    const value = event.target.value;
    setCryptoListNameValue(value);
  };
  const handleChangeConfirm = () => {
    if (cryptoListNameValue !== "") {
      setCryptoAssetData((prevCryptoAssetData) => {
        const updatedCryptoAsset = [...prevCryptoAssetData];

        updatedCryptoAsset[0].cryptoAssest.cryptoListName = cryptoListNameValue;
        return updatedCryptoAsset;
      });
      setForm1(!form1);
    }
    toggleCryptoList();
  };
  const toggleCryptoList = () => {
    setModal(false);
  };

  const [ownerName, setOwnerName] = useState([]);
  const handleChange = (
    event,
    newValue,
    field,
    index,
    type = "cryptoAssest"
  ) => {
    if (
      field === "coin" ||
      field === "storageType" ||
      field === "exchangeOrWallet"
    ) {
      setCryptoAssetData((prevCryptoAssetData) =>
        prevCryptoAssetData.map((item, i) =>
          i === index
            ? {
                ...item,
                [type]: {
                  ...item[type],
                  [field]: newValue,
                  otherExchangeOrWallet:
                    field === "otherExchangeOrWallet" && newValue !== "Other"
                      ? ""
                      : "",
                  exchangeOrWallet: field === "storageType" ? "" : newValue,
                },
              }
            : item
        )
      );
    }

    if (field === "owner") {
      const ownerString = Array.isArray(newValue)
        ? newValue.join(", ")
        : newValue;

      setCryptoAssetData((prevCryptoAssetData) =>
        prevCryptoAssetData.map((item, i) =>
          i === index
            ? {
                ...item,
                [type]: {
                  ...item[type],
                  owner: ownerString,
                },
              }
            : item
        )
      );
      setOwnerName((prevOwnerNames) => {
        const updatedOwnerNames = [...prevOwnerNames];
        updatedOwnerNames[index] = newValue;
        return updatedOwnerNames;
      });
    }
  };
  const [ownerNames, setOwnerNames] = useState([]);

  const primaryUserDetails = getUser();
  const primaryUserName =
    primaryUserDetails.firstName + " " + primaryUserDetails.lastName;

  const secondaryUserDetails = getSecondaryUser();
  useEffect(() => {
    const fetchOwnerData = async () => {
      const userId = getUser().commonId;
      const token = "Bearer " + getToken();

      try {
        const resp = await getOwnerByUserId(token, userId);
        const names = [primaryUserName];

        if (secondaryUserDetails !== undefined) {
          const secondaryUserName = `${secondaryUserDetails.firstName} ${secondaryUserDetails.lastName}`;
          names.push(secondaryUserName);
        }
        resp.forEach((user) => {
          const fullName = `${user.firstName} ${user.lastName}`;
          names.push(fullName);
        });
        setOwnerNames(names);
      } catch {
        toast.error("Failed to fetch owner data");
      }
    };

    fetchOwnerData();
  }, []);

  const [assetIndexValue, setAssetIndexValue] = useState(0);
  const [sharedTypeArray, setSharedTypeArray] = useState([]);
  const handleChanges = (e, field, index, type = "cryptoAssest") => {
    setAssetIndexValue(index);
    const { value } = e.target;
    const errorStates = { ...errors };

    if (!errorStates.cryptoValueData[index]) {
      errorStates.cryptoValueData[index] = {
        quantityZeroValidate: true,
      };
    }

    if (field === "sharedType") {
      setSharedTypeArray((prev) => {
        const updated = [...prev];
        updated[index] = value;
        return updated;
      });

      setCryptoAssetData((prevCryptoAssetData) => {
        return prevCryptoAssetData.map((crypto, i) => {
          if (i === index) {
            return {
              ...crypto,
              sharedDetails: [
                {
                  distributedType: "",
                  distributedValue: "",
                  distributedAmount: "",
                  beneficiaryId: "",
                },
              ],
              [type]: {
                ...crypto[type],
                trust: "",
              },
            };
          }
          return crypto;
        });
      });
    } else {
      setCryptoAssetData((prevCryptoAssetData) => {
        return prevCryptoAssetData.map((crypto, i) => {
          if (i !== index) return crypto;

          if (field === "cryptoListName") {
            return {
              ...crypto,
              [type]: {
                ...crypto[type],
                cryptoListName: value,
              },
            };
          }
          if (field === "quantity") {
            const quantityValue = Number(value);

            let priceValue = 0;
            const selectedCoin = cryptoAssetData[index]?.cryptoAssest?.coin;

            if (selectedCoin === "Bitcoin") {
              priceValue = bitcoinPrice;
            } else if (selectedCoin === "Ethereum") {
              priceValue = ethereumPrice;
            }
            if (!priceValue) {
              const fetchPrice =
                selectedCoin === "Bitcoin"
                  ? getCachedBitcoinPrice
                  : getCachedEthereumPrice;
              fetchPrice().then((latestPrice) => {
                if (latestPrice) {
                  selectedCoin === "Bitcoin"
                    ? setBitcoinPrice(latestPrice)
                    : setEthereumPrice(latestPrice);
                } else {
                  console.warn(`Could not fetch ${selectedCoin} price`);
                }
              });
            }
            priceValue = priceValue ? Number(priceValue) : 0;
            const calculatedValue =
              priceValue > 0 ? (quantityValue * priceValue).toFixed(2) : "0";
            errorStates.cryptoValueData[index].quantityZeroValidate =
              quantityValue > 0;
            return {
              ...crypto,
              [type]: {
                ...crypto[type],
                quantity: value,
                estValue: calculatedValue,
              },
            };
          }
          return {
            ...crypto,
            [type]: {
              ...crypto[type],
              [field]: value,
            },
          };
        });
      });
    }

    setErrors(errorStates);
  };


  const resetForm = () => {
    setFiles([]);
    setOwnerName([]);
    setCryptoAssetData([getInitialCryptoData()]);
    setSharedTypeArray([]);
    setCryptoListNameValue("");
    setErrors({
      cryptoValueData: [],
    });
  };

  const funcNetWorthStatus = () => {
    updateCryptoNetWorthStatus(
      existingCryptoListName,
      isChecked === true ? "false" : "true"
    )
      .then((resp) => {
        toast.success(resp, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        AddCard();
      })
      .catch((error) => {});
  };

  const [isChecked, setIsChecked] = useState(null);
  const handleSwitchChange = () => {
    setIsChecked(!isChecked);
    funcNetWorthStatus();
  };

  const [isPublic, setIsPublic] = useState(false);

  const handleSwitchChange1 = () => {
    const newStatus = !isPublic;
    setIsPublic(newStatus);
    funcPublicStatus(newStatus);
  };

  const funcPublicStatus = (newStatus) => {
    if (!Array.isArray(showDetail) || showDetail.length === 0) return;

    const listName = showDetail[0].cryptoAssest.cryptoListName;
    const newStatusString = newStatus ? "true" : "false";

    updateCryptoPublicStatus(listName, newStatusString)
      .then(() => {
        toast.success("Public status updated successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
        });

        const updatedShowDetail = showDetail.map((item) => ({
          ...item,
          cryptoAssest: { ...item.cryptoAssest, isPublic: newStatusString },
        }));
        setShowDetail(updatedShowDetail);

        AddCard();
      })
      .catch(() => {
        toast.error("Failed to update public status", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setIsPublic(!newStatus);
      });
  };

  const cryptoForm = (event) => {
    event.preventDefault();

    const hasErrors = errors.cryptoValueData.some(
      (cryptoValue) => !cryptoValue.quantityZeroValidate
    );

    if (!hasErrors) {
      let token = "Bearer " + getToken();
      const formData = new FormData();

      formData.append("data", JSON.stringify(cryptoAssetData));
      Object.keys(files).forEach((index) => {
        files[index].forEach((file) => {
          formData.append(`files${index}`, file);
        });
      });

      cryptoAssests(formData, token)
        .then((resp) => {
          AddCard();
          toast.success("Data Added !!", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          fetchNetWorth(primaryUserDetails.commonId);
          toggle(null, null, null, "close");
        })
        .catch((error) => {});
    }
  };

  const [showConfirmationDelete, setShowConfirmationDelete] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [currentIdType, setCurrentIdType] = useState("");
  const removeCrypto = (id, idType) => {
    setShowConfirmationDelete(true);
    setCurrentId(id);
    setCurrentIdType(idType);
  };

  const handleConfirmationDeleteClose = () => {
    setShowConfirmationDelete(false);
  };

  const handleRemove = (params) => {
    setShowConfirmationDelete(false);
    const { Id, idType } = params;
    if (idType === "cryptoId") {
      deleteCryptoAssest(Id)
        .then((res) => {
          toast.success("Deleted successfully...", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          fetchNetWorth(primaryUserDetails.commonId);
          AddCard();
          setShow1(false);
        })
        .catch((error) => {});
    } else {
      deleteSingleProperty(Id)
        .then((res) => {
          setBeneficiaryVisible(!beneficiaryVisible);
          setShow(false);
          AddCard();
          toast.success("Deleted successfully...", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          fetchNetWorth(primaryUserDetails.commonId);
        })
        .catch((error) => {});
    }
  };

  const handleDownload = (id, fileName) => {
    let myarry = fileName.split(".");
    downloadDocument1(id)
      .then((response) => {
        const downloadUrl = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `${myarry[0]}.${myarry[1]}`;
        link.click();
        URL.revokeObjectURL(downloadUrl);
      })
      .catch((error) => {});
  };

  const [bitcoinPrice, setBitcoinPrice] = useState(null);
  const [ethereumPrice, setEthereumPrice] = useState(null);

  const [popupVisible, setPopupVisible] = useState(false);
  const [selectedNote, setSelectedNote] = useState("");
  const handleOpenPopup = (note) => {
    setSelectedNote(note);
    setPopupVisible(true);
  };

  const [popupVisibleDownlaod, setPopupVisibleDownlaod] = useState(false);
  const [selectedDownlaod, setSelectDownload] = useState("");

  const handleShowDownlaod = (showDetail) => {
    setPopupVisibleDownlaod(true);
    setSelectDownload(showDetail);
  };
  const [show, setShow] = useState(false);
  let [form1, setForm1] = useState(false);

  const [existingCryptoListName, setExistingCryptoListName] = useState(null);
  const [existingIsPartOfNetWorthValue, setExistingIsPartOfNetWorthValue] = useState(true);
  const [existingIsPublic, setExistingIsPublic] = useState(null);
  const toggle = (event, value, isPartOfNetWorthValue, isPublic, closePopup) => {
    setExistingCryptoListName(value);
    setExistingIsPartOfNetWorthValue(isPartOfNetWorthValue);
    setExistingIsPublic(isPublic);
    resetForm();
    if (closePopup) {
      setForm1(false);
      setCryptoListNameValue("");
      setExistingIsPartOfNetWorthValue("");
      return;
    }
    if (value) {
      setForm1(true);
    } else {
      if (cryptoListNameValue !== "") {
        setForm1(false);
      } else {
        setModal(true);
      }
    }
  };

  useEffect(() => {
    if (existingCryptoListName) {
      setCryptoAssetData((prevCryptoAssetData) =>
        prevCryptoAssetData.map((item) => ({
          ...item,
          cryptoAssest: {
            ...item.cryptoAssest,
            cryptoListName: existingCryptoListName,
            isPartOfNetWorth: existingIsPartOfNetWorthValue,
            isPublic: existingIsPublic,
          },
        }))
      );
    }
  }, [existingCryptoListName, existingIsPartOfNetWorthValue, existingIsPublic]);

  let [card, setCard] = useState([]);
  let [showDetail, setShowDetail] = useState([]);
  let [show1, setShow1] = useState(false);

  const AddCard = () => {
    let userId = getUser().commonId;
    let token = "Bearer " + getToken();
    getCryptoAssests(token, userId)
      .then((res) => {
        setCard(res);
      })
      .catch((error) => {
        setCard([]);
      });
  };

  const Showdetails = (obj) => {
    setShowDetail(obj);
    setShow1(true);

    setIsChecked(
      obj[0].cryptoAssest.isPartOfNetWorth !== null
        ? obj[0].cryptoAssest.isPartOfNetWorth === "true"
          ? true
          : false
        : true
    );
    setIsPublic(obj[0].cryptoAssest.isPublic === "true");
    setExistingCryptoListName(obj[0].cryptoAssest.cryptoListName);
    setExistingIsPublic(obj[0].cryptoAssest.isPublic);
  };

  const [beneficiary, setBenificiary] = useState([]);
  const getBenificiarydata = () => {
    let userId = getUser().commonId;
    let token = "Bearer " + getToken();
    getBeneficiary(token, userId)
      .then((res) => {
        setBenificiary(res);
      })
      .catch((err) => {});
  };

  const [benevisible, setbeneVisible] = useState(false);

  const [beneficiaryVisible, setBeneficiaryVisible] = useState(false);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState("");

  const handleShowBeneficiary = (event, indexValue) => {
    setShow1(false);
    setAssetIndexValue(indexValue);
    setbeneVisible(true);
  };
  const handleOpenBeneficiary = (showDetail) => {
    setSelectedBeneficiary(showDetail);
    setBeneficiaryVisible(true);
  };

  const handleCloseBeneficiaryPopup = (params) => {
    const { name } = params;
    if (name !== undefined) {
      setCryptoAssetData((prev) => {
        const updatedCryptoAsset = [...prev];
        updatedCryptoAsset[assetIndexValue].sharedDetails = name;
        return updatedCryptoAsset;
      });
    }
    setbeneVisible(false);
  };

  const handleReset = () => {
    setbeneVisible(false);
  };

  const [trusts, setTrusts] = useState([]);
  const getTrustsData = () => {
    let userId = getUser().commonId;

    let token = "Bearer " + getToken();
    getTrustByUserId(token, userId)
      .then((res) => {
        setTrusts(res);
      })
      .catch((err) => {});
  };
  const handleTrustSave = () => {
    setbeneVisible(false);
  };
  const getBenificiaryName = (id) => {
    let beneficiaryIdToLookup;
    if (typeof id === "object" && id !== null && id.BeneficiaryId !== undefined) {
      beneficiaryIdToLookup = id.BeneficiaryId;
    } else {
      beneficiaryIdToLookup = id;
    }
    const numericId = parseInt(beneficiaryIdToLookup, 10);
    if (isNaN(numericId)) {
      return "";
    }
    const foundBenificiary = beneficiary.find((b) => b.id === numericId);
    if (foundBenificiary) {
      return `${foundBenificiary.firstName} ${foundBenificiary.lastName}`;
    } else {
      return "Beneficiary not found";
    }
  };
  useEffect(() => {
    AddCard();
    getBenificiarydata();
    getTrustsData();
    if (bitcoinPrice || ethereumPrice) {
      setCryptoAssetData((prevCryptoAssetData) =>
        prevCryptoAssetData.map((crypto) => {
          const coin = crypto.cryptoAssest.coin;
          const quantity = crypto.cryptoAssest.quantity;

          let price = 0;
          if (coin === "Bitcoin") {
            price = bitcoinPrice;
          } else if (coin === "Ethereum") {
            price = ethereumPrice;
          }

          const estValue = (parseFloat(quantity) * price).toFixed(2);

          return {
            ...crypto,
            cryptoAssest: {
              ...crypto.cryptoAssest,
              estValue,
            },
          };
        })
      );

      AddCard();
      setShow(true);
    }
  }, [bitcoinPrice, ethereumPrice]);

  const addCryptoRow = () => {
    setCryptoAssetData((prevCryptoAssetData) => [
      ...prevCryptoAssetData,
      {
        ...getInitialCryptoData(),
        cryptoAssest: {
          ...getInitialCryptoData().cryptoAssest,
          cryptoListName:
            prevCryptoAssetData[0]?.cryptoAssest.cryptoListName || "",
          isPartOfNetWorth:
            prevCryptoAssetData[0]?.cryptoAssest.isPartOfNetWorth || "",
          isPublic: prevCryptoAssetData[0]?.cryptoAssest.isPublic || "false",
        },
        sharedDetails: [
          {
            distributedType: "",
            distributedValue: "",
            distributedAmount: "",
            beneficiaryId: "",
          },
        ],
      },
    ]);

    setErrors((prevErrors) => ({
      ...prevErrors,
      cryptoValueData: [
        ...prevErrors.cryptoValueData,
        { quantityZeroValidate: true },
      ],
    }));
  };

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const removeCryptoRow = (index) => {
    setShowConfirmation(true);
    setCurrentIndex(index);
  };

  const handleConfirmation = () => {
    setShowConfirmation(false);
    const index = currentIndex;
    setCryptoAssetData(cryptoAssetData.filter((_, i) => i !== index));

    setFiles((prevFiles) => {
      const updatedFiles = Object.keys(prevFiles).reduce((acc, key) => {
        const numericKey = parseInt(key, 10);
        if (numericKey !== index) {
          const newIndex = numericKey > index ? numericKey - 1 : numericKey;
          acc[newIndex] = prevFiles[key];
        }
        return acc;
      }, {});

      return updatedFiles;
    });

    setOwnerName((prevOwnerNames) => {
      const updatedOwnerNames = prevOwnerNames.filter((_, i) => i !== index);
      return updatedOwnerNames;
    });

    setErrors((prevErrors) => {
      const updatedCryptoValueData = prevErrors.cryptoValueData.filter(
        (_, i) => i !== index
      );

      return {
        ...prevErrors,
        cryptoValueData: updatedCryptoValueData,
      };
    });
  };

  const handleConfirmationClose = () => {
    setShowConfirmation(false);
  };

  const consolidated = card.reduce((acc, item) => {
    const listName = item.cryptoAssest.cryptoListName;
    const partOfNetWorthValue = item.cryptoAssest.isPartOfNetWorth;
    const isPublicValue = item.cryptoAssest.isPublic;
    const cryptoValue = parseFloat(item.cryptoAssest.estValue) || 0;
    if (!acc[listName]) {
      acc[listName] = {
        cryptoListName: listName,
        isPartOfNetWorth: partOfNetWorthValue,
        isPublic: isPublicValue,
        cryptoValue: 0,
        data: [],
      };
    }

    acc[listName].cryptoValue += cryptoValue;
    acc[listName].data.push({
      cryptoAssest: item.cryptoAssest,
      documents: item.documents,
      sharedDetails: item.sharedDetails,
    });

    return acc;
  }, {});
  const [viewDetailFile, setViewDetailFile] = useState(null);
    const uniqueListDocuments = showDetail && Array.isArray(showDetail)
      ? [...new Map(
          showDetail.flatMap(item => item.documents || [])
          .map(doc => [doc.id, doc])
        ).values()]
      : [];
    const handleUnifiedDocumentUpload = () => {
             if (!viewDetailFile) {
               toast.error("Please select a file to upload");
               return;
             }

             const maxFileSize = 4 * 1024 * 1024;

             if (viewDetailFile.size > maxFileSize) {
               toast.error("Please upload a PDF under 4 MB.", {
                 position: toast.POSITION.BOTTOM_CENTER,
               });
               return;
             }

             const listName = showDetail[0].cryptoAssest.cryptoListName;
             const token = "Bearer " + getToken();
             const formData = new FormData();

             formData.append("file", viewDetailFile);
             formData.append("listName", listName);

             updateDocumentApi(formData, token)
               .then(() => {
                 toast.success("Documents updated successfully!", {
                   position: toast.POSITION.BOTTOM_CENTER,
                 });
                 setViewDetailFile(null);
                 AddCard();
                 setShow1(false);
               })
               .catch((error) => {
                 console.error(error);
                 toast.error("Failed to update documents");
               });
           };
  const uniqueCryptoListResult = Object.values(consolidated);

  return (
    <div className={`your-component ${show ? "fade-in-element" : ""}`}>
      <UserBase>
        <div className="mt-5"></div>
        <SideBar>
          {primaryUserDetails.accountType === "secondary" &&
          secondaryUserDetails.accountType === "primary" &&
          secondaryUserDetails.isSecondaryUserEditable === "false" ? (
            ""
          ) : (
            <div className="addme">
              <div className="addme_inner">
                <button onClick={() => toggle()}>Add New Bitcoin</button>
              </div>
            </div>
          )}

          <div className="propCard">
            <div className="propCard-card">
              {uniqueCryptoListResult.map((item, index) => (
                <div
                  className="propCard-card-body"
                  style={{ padding: "20px 20px 10px 20px" }}
                >
                  <div className="propCard_card_status">
                    <p
                      className={`propCard_card_status_text ${
                        item.data.every(
                          (dataItem) =>
                            dataItem.sharedDetails.length > 0 ||
                            (dataItem.cryptoAssest.trust &&
                              dataItem.cryptoAssest.trust !== "" &&
                              dataItem.cryptoAssest.trust !== null)
                        )
                          ? "completed"
                          : "incomplete"
                      }`}
                    >
                      {item.data.every(
                        (dataItem) =>
                          dataItem.sharedDetails.length > 0 ||
                          (dataItem.cryptoAssest.trust &&
                            dataItem.cryptoAssest.trust !== "" &&
                            dataItem.cryptoAssest.trust !== null)
                      )
                        ? "completed"
                        : "incomplete"}
                    </p>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <h5 className="propCard-card-title">
                    {item.cryptoListName}
                    </h5>
                    <span style={{ color: "green" }}>
                      {formatAmount(item.cryptoValue)}
                    </span>
                    </div>
                  <div className="propCard-btn">
                    <p className="viewDetails">
                      <button
                        className="jewelry_add_more"
                        onClick={(event) =>
                          toggle(
                            event,
                            item.cryptoListName,
                            item.isPartOfNetWorth
                          )
                        }
                      >
                        Add More
                      </button>
                      <button
                        style={{ margin: "10px 0" }}
                        onClick={() => Showdetails(item.data)}
                      >
                        View Details
                      </button>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {form1 && (
            <div
              className="overlay1"
              style={{ transition: "500ms", height: "" }}
            >
              <div>
                <Form onSubmit={cryptoForm} className="addform_body">
                  <container>
                    <div className="homepage jewelry_container">
                      <Card>
                        <CardHeader>
                          <div
                            style={{ width: "100%" }}
                            className="addform_heading"
                          >
                            <h3 className="addform_heading_h1">
                              {cryptoListNameValue && cryptoListNameValue}
                              {existingCryptoListName && existingCryptoListName}
                            </h3>
                            <div
                              className="addform_close"
                              onClick={(event) =>
                                toggle(event, "", "", "close")
                              }
                            >
                              <FontAwesomeIcon icon={faXmark} />
                            </div>
                          </div>
                        </CardHeader>
                        <CardBody className="jewelry_card_body">
                          <div>
                            <p className="crypto_note">
                              NOTE: DO NOT STORE YOUR SEED PHRASES ON ANY
                              ELECTRONIC PLATFORM, INCLUDING I
                              <span style={{ color: "green" }}>-</span>
                              CHEST.COM, GOOGLE DOC ETC.
                            </p>
                            <table className="jewelry_table">
                              <thead>
                                <tr>
                                  <th className="crypto_132px">
                                    Select Owner*
                                  </th>
                                  <th className="crypto_115px">Heading</th>
                                  <th className="crypto_115px">Select Coin*</th>
                                  <th className="crypto_115px">
                                    Select Exchange/Wallet*
                                  </th>
                                  <th className="crypto_100px">Quantity*</th>
                                  <th className="crypto_100px">Value*</th>

                                  <th>Beneficiary*</th>
                                  <th>Notes</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {cryptoAssetData.map((row, index) => (
                                  <tr key={index}>
                                    <td>
                                      <Select
                                        className="crypto_select crypto_132px"
                                        placeholder="Owner"
                                        value={ownerName[index] || []}
                                        multiple
                                        onChange={(event, newValue) =>
                                          handleChange(
                                            event,
                                            newValue,
                                            "owner",
                                            index
                                          )
                                        }
                                        required
                                      >
                                        {ownerNames.map((name) => (
                                          <Option key={name} value={name}>
                                            {name}
                                          </Option>
                                        ))}
                                      </Select>
                                    </td>

                                    <td>
                                      <Input
                                        className="crypto_input crypto_115px"
                                        placeholder="Heading"
                                        onChange={(e) =>
                                          handleChanges(
                                            e,
                                            "heading",
                                            index,
                                            "cryptoAssest"
                                          )
                                        }
                                        value={
                                          cryptoAssetData[index].cryptoAssest
                                            .heading
                                        }
                                      />
                                    </td>

                                    <td>
                                      <Select
                                        className="crypto_select crypto_115px"
                                        value={
                                          cryptoAssetData[index]?.cryptoAssest
                                            .coin
                                        }
                                        onChange={(event, newValue) =>
                                          handleChange(
                                            event,
                                            newValue,
                                            "coin",
                                            index
                                          )
                                        }
                                        required
                                      >
                                        <Option value="">Select coin</Option>
                                        <Option value="Bitcoin">Bitcoin</Option>
                                        <Option value="Ethereum">Ethereum</Option>
                                      </Select>
                                    </td>

                                    <td>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          gap: "2px",
                                        }}
                                      >
                                        <Select
                                          className="crypto_select crypto_115px"
                                          value={
                                            cryptoAssetData[index].cryptoAssest
                                              .storageType
                                          }
                                          onChange={(event, newValue) =>
                                            handleChange(
                                              event,
                                              newValue,
                                              "storageType",
                                              index
                                            )
                                          }
                                          required
                                        >
                                          <Option value="">Select one</Option>
                                          <Option value="Exchange">
                                            Exchange
                                          </Option>
                                          <Option value="Wallet">Wallet</Option>
                                        </Select>

                                        {cryptoAssetData[index].cryptoAssest
                                          .storageType === "" ||
                                        cryptoAssetData[index].cryptoAssest
                                          .storageType === "Exchange" ? (
                                          <>
                                            <Select
                                              className="crypto_115px"
                                              value={
                                                cryptoAssetData[index]
                                                  .cryptoAssest.exchangeOrWallet
                                              }
                                              onChange={(event, newValue) =>
                                                handleChange(
                                                  event,
                                                  newValue,
                                                  "exchangeOrWallet",
                                                  index
                                                )
                                              }
                                              required
                                            >
                                              <Option value="">
                                                Select exchange
                                              </Option>
                                              <Option value="Coinbase">
                                                Coinbase
                                              </Option>
                                              <Option value="Binance.US">
                                                Binance.US
                                              </Option>
                                              <Option value="Kraken">
                                                Kraken
                                              </Option>
                                              <Option value="Gemini">
                                                Gemini
                                              </Option>
                                              <Option value="Bitfinex">
                                                Bitfinex
                                              </Option>
                                              <Option value="Bitstamp">
                                                Bitstamp
                                              </Option>
                                              <Option value="Huobi US">
                                                Huobi US
                                              </Option>
                                              <Option value="Crypto.com">
                                                Crypto.com
                                              </Option>
                                              <Option value="BitFlyer">
                                                BitFlyer
                                              </Option>
                                              <Option value="OKCoin">
                                                OKCoin
                                              </Option>
                                              <Option value="Other">
                                                Other
                                              </Option>
                                            </Select>
                                            {cryptoAssetData[index].cryptoAssest
                                              .exchangeOrWallet === "Other" && (
                                              <Input
                                                className="crypto_input crypto_115px"
                                                placeholder="Other Exchange"
                                                onChange={(e) =>
                                                  handleChanges(
                                                    e,
                                                    "otherExchangeOrWallet",
                                                    index,
                                                    "cryptoAssest"
                                                  )
                                                }
                                                value={
                                                  cryptoAssetData[index]
                                                    .cryptoAssest
                                                    .otherExchangeOrWallet
                                                }
                                                required
                                              />
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <Select
                                              className="crypto_115px"
                                              value={
                                                cryptoAssetData[index]
                                                  .cryptoAssest.exchangeOrWallet
                                              }
                                              onChange={(event, newValue) =>
                                                handleChange(
                                                  event,
                                                  newValue,
                                                  "exchangeOrWallet",
                                                  index
                                                )
                                              }
                                              required
                                            >
                                              <Option value="">
                                                Select wallet
                                              </Option>
                                              <Option value="Ledger Nano S">
                                                Ledger Nano S
                                              </Option>
                                              <Option value="Trezor Model T">
                                                Trezor Model T
                                              </Option>
                                              <Option value="Exodus">
                                                Exodus
                                              </Option>
                                              <Option value="Atomic Wallet">
                                                Atomic Wallet
                                              </Option>
                                              <Option value="Trust Wallet">
                                                Trust Wallet
                                              </Option>
                                              <Option value="MyEtherWallet">
                                                MyEtherWallet
                                              </Option>
                                              <Option value="Coinomi">
                                                Coinomi
                                              </Option>
                                              <Option value="MetaMask">
                                                MetaMask
                                              </Option>
                                              <Option value="Freewallet">
                                                Freewallet
                                              </Option>
                                              <Option value="KeepKey">
                                                KeepKey
                                              </Option>
                                              <Option value="Other">
                                                Other
                                              </Option>
                                            </Select>
                                            {cryptoAssetData[index].cryptoAssest
                                              .exchangeOrWallet === "Other" && (
                                              <Input
                                                className="crypto_input crypto_115px"
                                                placeholder="Other Wallet"
                                                onChange={(e) =>
                                                  handleChanges(
                                                    e,
                                                    "otherExchangeOrWallet",
                                                    index,
                                                    "cryptoAssest"
                                                  )
                                                }
                                                value={
                                                  cryptoAssetData[index]
                                                    .cryptoAssest
                                                    .otherExchangeOrWallet
                                                }
                                                required
                                              />
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </td>

                                    <td>
                                      <Input
                                        className="crypto_input crypto_100px"
                                        type="number"
                                        placeholder="Quantity"
                                        onChange={(e) =>
                                          handleChanges(
                                            e,
                                            "quantity",
                                            index,
                                            "cryptoAssest"
                                          )
                                        }
                                        value={
                                          cryptoAssetData[index].cryptoAssest
                                            .quantity
                                        }
                                        required
                                      />
                                      {errors.cryptoValueData.length > index &&
                                        !errors?.cryptoValueData[index]
                                          .quantityZeroValidate && (
                                          <FormHelperText error>
                                            <Typography
                                              variant="caption"
                                              color="error"
                                              sx={{ fontSize: "9px" }}
                                            >
                                              Quantity can't be zero
                                            </Typography>
                                          </FormHelperText>
                                        )}
                                    </td>

                                    <td>
                                      <Input
                                        className="crypto_input crypto_100px"
                                        placeholder="Est Value"
                                        type="number"
                                        // onChange={(e) =>
                                        //   handleChanges(
                                        //     e,
                                        //     "estValue",
                                        //     index,
                                        //     "cryptoAssest"
                                        //   )
                                        // }
                                        value={cryptoAssetData[index]?.cryptoAssest?.estValue || "0"} // Use state value


                                        startDecorator={<div>$</div>}
                                        disabled
                                        required
                                      />
                                    </td>



                                    <td>
                                      <div
                                        className="bene-select beneficiary_btn"
                                        onClick={(e) =>
                                          handleShowBeneficiary(e, index)
                                        }
                                      >
                                        Beneficiary
                                      </div>
                                    </td>

                                    <td>
                                      <Textarea
                                        style={{ fontSize: "14px" }}
                                        placeholder="Notes"
                                        id="notes"
                                        value={
                                          cryptoAssetData[index].cryptoAssest
                                            .notes
                                        }
                                        onChange={(e) =>
                                          handleChanges(
                                            e,
                                            "notes",
                                            index,
                                            "cryptoAssest"
                                          )
                                        }
                                      />
                                    </td>

                                    <td>
                                      <div className="jewelry_action">
                                        {cryptoAssetData.length > 1 && (
                                          <Button
                                            className="jewelry_remove_button"
                                            onClick={() =>
                                              removeCryptoRow(index)
                                            }
                                          >
                                            <FontAwesomeIcon icon={faMinus} />
                                          </Button>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            <div style={{ marginTop: "8px" }}>
                              <Button
                                className="jewelry_add_more_button"
                                type="button"
                                onClick={addCryptoRow}
                              >
                                <FontAwesomeIcon icon={faPlus} />
                              </Button>
                            </div>
                            <div className="crypto_recommendations">
                              <div className="crypto_recommendation_base">
                                <input
                                  type="checkbox"
                                  className="crypto_check"
                                  required
                                />
                                <p>
                                  <span style={{ fontWeight: "bold" }}>
                                    Secure your Bitcoin
                                  </span>{" "}
                                  with a hardware wallet or paper wallet.
                                </p>
                              </div>
                              <div className="crypto_recommendation_base">
                                <input
                                  type="checkbox"
                                  className="crypto_check"
                                  required
                                />
                                <p>
                                  <span style={{ fontWeight: "bold" }}>
                                    Create a detailed plan
                                  </span>{" "}
                                  including a will or trust that outlines how
                                  your Bitcoin should be transferred.
                                </p>
                              </div>
                              <div className="crypto_recommendation_base">
                                <input
                                  type="checkbox"
                                  className="crypto_check"
                                  required
                                />
                                <p>
                                  <span style={{ fontWeight: "bold" }}>
                                    Provide clear instructions
                                  </span>{" "}
                                  on accessing Bitcoin and ensuring your heir
                                  understands them.
                                </p>
                              </div>
                              <div className="crypto_recommendation_base">
                                <input
                                  type="checkbox"
                                  className="crypto_check"
                                  required
                                />
                                <p>
                                  <span style={{ fontWeight: "bold" }}>
                                    Consult professionals
                                  </span>{" "}
                                  for legal and tax advice
                                </p>
                              </div>
                              <div className="crypto_recommendation_base">
                                <p>
                                  <span style={{ fontWeight: "bold" }}>
                                    Third Party applications like UnChained.com
                                    are suitable for safe transfer to heirs
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                        <CardFooter>
                          <div className="text-center">
                            <Button
                              className="my-estate-clear-btn"
                              onClick={resetForm}
                              type="reset"
                              outline
                            >
                              Clear
                            </Button>
                            <Button
                              outline
                              type=""
                              className="my-estate-add-btn"
                            >
                              Add
                            </Button>
                          </div>
                        </CardFooter>
                      </Card>
                    </div>
                  </container>
                </Form>
              </div>
            </div>
          )}

          {modal && (
            <div>
              <Modal
                show={modal}
                toggle={toggleCryptoList}
                style={{ paddingTop: "50px" }}
              >
                <ModalBody style={{ color: "black" }}>
                  Please create your bitcoin catalog here:
                  <div>
                    <Input
                      type="text"
                      value={cryptoListNameValue}
                      placeholder="Enter your bitcoin catalog name"
                      onChange={handleChangeAddCryptoListName}
                    />
                  </div>
                </ModalBody>
                <ModalFooter style={{ padding: "5px" }}>
                  <Button
                    className="confirm_delete_btn"
                    onClick={handleChangeConfirm}
                  >
                    Add
                  </Button>{" "}
                  <Button
                    className="confirm_cancel_btn"
                    onClick={toggleCryptoList}
                  >
                    Cancel
                  </Button>
                </ModalFooter>
              </Modal>
            </div>
          )}

          {show1 && (
            <>
              <div className="popup">
                <div className="popup-content popup-content-download">
                  <div className="note_popup">
                    <div className="note_popup_heading">
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <h2>{`${showDetail[0]?.cryptoAssest?.cryptoListName} Details`}</h2>
                      </div>
                      <div>
                        <button
                          className="note_popup_heading_close_btn"
                          onClick={() => {
                            setShow1(false);
                          }}
                        >
                          <FontAwesomeIcon icon={faXmark} />
                        </button>
                      </div>
                    </div>
                    <div
                      style={{ margin: "5px" }}
                      className="mt-2 switch_changes_main"
                    >
                      <div className="switch_changes_base">
                        <div>
                          Do you want to include the total list value as part of
                          your net worth?
                        </div>
                        <div>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isChecked}
                                onChange={(event) => {
                                  handleSwitchChange(event);
                                }}
                                color="primary"
                                size="normal"
                              />
                            }
                            label={isChecked ? "Yes" : "No"}
                            labelPlacement="end"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                    style={{ margin: "5px" }}
                                          className="mt-2 switch_changes_main"
                                        >
                                          <div className="switch_changes_base">
                                            <div>
                                              Do you want this asset to be visible to your agent?
                                            </div>
                                            <div>
                                              <FormControlLabel
                                                control={
                                                  <Switch
                                                    checked={isPublic}
                                                    onChange={(event) => {
                                                      handleSwitchChange1(event);
                                                    }}
                                                    color="primary"
                                                    size="normal"
                                                  />
                                                }
                                                label={isPublic ? "Yes" : "No"}
                                                labelPlacement="end"
                                              />
                                            </div>
                                          </div>
                                        </div>

                                        <div
                                                              style={{ margin: "5px" }}
                                                              className="mt-2 switch_changes_main"
                                                            >
                                                              <div className="switch_changes_base">
                                                                <div>
                                                                  Upload Document for this List:
                                                                </div>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                  <input
                                                                    type="file"
                                                                    accept=".pdf"
                                                                    onChange={(e) => setViewDetailFile(e.target.files[0])}
                                                                    style={{ maxWidth: '200px' }}
                                                                  />
                                                                  <Button
                                                                    color="primary"
                                                                    size="sm"
                                                                    onClick={handleUnifiedDocumentUpload}
                                                                    disabled={!viewDetailFile}
                                                                  >
                                                                    <FontAwesomeIcon icon={faUpload} className="me-2" />
                                                                    Upload
                                                                  </Button>
                                                                </div>
                                                              </div>
                                                            </div>

                                                            {uniqueListDocuments.length > 0 && (
                                                                                                                                                                                      <div style={{ margin: "5px" }} className="mt-2 switch_changes_main">
                                                                                                                                                                                        <div className="switch_changes_base">
                                                                                                                                                                                          <div>Download Documents for this List:</div>
                                                                                                                                                                                          <div style={{ display: "flex", alignItems: "center" }}>
                                                                                                                                                                                            <div className="me-2">
                                                                                                                                                                                              <Tooltip title="click to see multiple download files">
                                                                                                                                                                                                <div
                                                                                                                                                                                                  style={{ cursor: "pointer" }}
                                                                                                                                                                                                  onClick={() => {
                                                                                                                                                                                                    handleShowDownlaod({ documents: uniqueListDocuments });
                                                                                                                                                                                                    setShow1(false);
                                                                                                                                                                                                  }}
                                                                                                                                                                                                >
                                                                                                                                                                                                  <div className="myestate_download_button dwnbtn">
                                                                                                                                                                                                    <FontAwesomeIcon
                                                                                                                                                                                                      className="myestate_download_icon"
                                                                                                                                                                                                      icon={faDownload}
                                                                                                                                                                                                    />
                                                                                                                                                                                                    <span></span>
                                                                                                                                                                                                  </div>
                                                                                                                                                                                                </div>
                                                                                                                                                                                              </Tooltip>
                                                                                                                                                                                            </div>
                                                                                                                                                                                          </div>
                                                                                                                                                                                        </div>
                                                                                                                                                                                      </div>
                                                                                                                                                                                    )}
                    <div>
                      {showDetail.map((details, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            padding: "10px",
                            border: "solid 1px lightgray",
                            borderRadius: "5px",
                            minWidth: "230px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            {/* Left side */}
                            <div>
                              <p
                                style={{
                                  fontSize: "17px",
                                  color: "black",
                                  fontWeight: "500",
                                }}
                              >
                                {`Item - ${index + 1}`}
                                {"  "}
                                <span
                                  className={`propCard_card_status_text ${
                                    details.sharedDetails.length > 0 ||
                                    (details.cryptoAssest.trust &&
                                      details.cryptoAssest.trust !== "" &&
                                      details.cryptoAssest.trust !== null)
                                      ? "completed"
                                      : "incomplete"
                                  }`}
                                >
                                  {details.sharedDetails.length > 0 ||
                                  (details.cryptoAssest.trust &&
                                    details.cryptoAssest.trust !== "" &&
                                    details.cryptoAssest.trust !== null)
                                    ? "completed"
                                    : "incomplete"}
                                </span>
                              </p>
                            </div>
                            {/* Right side */}
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {primaryUserDetails.accountType === "secondary" &&
                              secondaryUserDetails.accountType === "primary" &&
                              secondaryUserDetails.isSecondaryUserEditable ===
                                "false" ? (
                                ""
                              ) : (
                                <div className="me-2">
                                  <Tooltip title="Click Here To Edit">
                                    <div>
                                      <UpdateButton
                                        URL={"../my-estate/crypto/"}
                                        id={details.cryptoAssest.id}
                                      />
                                    </div>
                                  </Tooltip>
                                </div>
                              )}

                              {primaryUserDetails.accountType === "secondary" &&
                              secondaryUserDetails.accountType === "primary" &&
                              secondaryUserDetails.isSecondaryUserEditable ===
                                "false" ? (
                                ""
                              ) : (
                                <FontAwesomeIcon
                                  onClick={() =>
                                    removeCrypto(
                                      details.cryptoAssest.id,
                                      "cryptoId"
                                    )
                                  }
                                  className="delete-button-comp"
                                  style={{ cursor: "pointer" }}
                                  icon={faTrash}
                                />
                              )}
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",

                              flexWrap: "wrap",
                            }}
                            className="mt-2"
                          >
                            {/* Left section */}
                            <div style={{ flex: "1", minWidth: "250px" }}>
                              {details.cryptoAssest.owner && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                >
                                  Owner :{" "}
                                  {details.cryptoAssest.owner && (
                                    <span>{details.cryptoAssest.owner}</span>
                                  )}
                                </p>
                              )}

                              {details.cryptoAssest.heading && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                >
                                  Heading :{" "}
                                  <span>
                                    {details.cryptoAssest.heading && (
                                      <span>
                                        {details.cryptoAssest.heading}
                                      </span>
                                    )}
                                  </span>
                                </p>
                              )}

                              {details.cryptoAssest.coin && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                >
                                  Coin :{" "}
                                  <span>
                                    {details.cryptoAssest.coin && (
                                      <span>{details.cryptoAssest.coin}</span>
                                    )}
                                  </span>
                                </p>
                              )}

                              {details.cryptoAssest.storageType ===
                              "Exchange" ? (
                                <p
                                  style={{
                                    color: "black",
                                    fontWeight: "500",
                                  }}
                                >
                                  Exchange :{" "}
                                  <span>
                                    {details.cryptoAssest.exchangeOrWallet ===
                                    "Other" ? (
                                      <span>
                                        {
                                          details.cryptoAssest
                                            .otherExchangeOrWallet
                                        }
                                      </span>
                                    ) : (
                                      <span>
                                        {details.cryptoAssest.exchangeOrWallet}
                                      </span>
                                    )}
                                  </span>
                                </p>
                              ) : (
                                <>
                                  <p
                                    style={{
                                      color: "black",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Wallet :{" "}
                                    <span>
                                      {details.cryptoAssest.exchangeOrWallet ===
                                      "Other" ? (
                                        <span>
                                          {
                                            details.cryptoAssest
                                              .otherExchangeOrWallet
                                          }
                                        </span>
                                      ) : (
                                        <span>
                                          {
                                            details.cryptoAssest
                                              .exchangeOrWallet
                                          }
                                        </span>
                                      )}
                                    </span>
                                  </p>
                                </>
                              )}
                            </div>

                            {/* Right section */}
                            <div style={{ flex: "0.5", minWidth: "250px" }}>
                              <p style={{ color: "black", fontWeight: "500" }}>
                                Quantity :{" "}
                                <span>
                                  {details.cryptoAssest.quantity && (
                                    <span>{details.cryptoAssest.quantity}</span>
                                  )}
                                </span>
                              </p>
                              <p style={{ color: "black", fontWeight: "500" }}>
                                Estimated Value :{" "}
                                <span style={{ color: "green", fontWeight: "bold" }}>
                                  {details.cryptoAssest.estValue
                                    ? `${Number(details.cryptoAssest.estValue).toFixed(2)}`
                                    : "$0.00"}
                                </span>
                              </p>
                              {details.sharedDetails[0] && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                  onClick={() => {
                                    handleOpenBeneficiary(details);
                                    setShow1(false);
                                  }}
                                >
                                  Beneficiary Details{" "}
                                  <span>
                                    <span className="readmore">Click Here</span>
                                  </span>
                                </p>
                              )}

                              {details.cryptoAssest.trust && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                >
                                  Trust Name :{" "}
                                  <span>
                                    {details.cryptoAssest.trust && (
                                      <span>{details.cryptoAssest.trust}</span>
                                    )}
                                  </span>
                                </p>
                              )}

                              {details.cryptoAssest.notes && (
                                <Tooltip title="Click To see Note">
                                  <p
                                    style={{
                                      color: "black",
                                      fontWeight: "500",
                                    }}
                                    onClick={() => {
                                      handleOpenPopup(
                                        details.cryptoAssest.notes
                                      );
                                      setShow1(!show1);
                                    }}
                                  >
                                    Note:{" "}
                                    <span>
                                      {" "}
                                      {details && details.cryptoAssest.notes
                                        ? details.cryptoAssest.notes.slice(0, 5)
                                        : ""}
                                      ...
                                      <span className="readmore">
                                        Read More
                                      </span>
                                    </span>
                                  </p>
                                </Tooltip>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {showConfirmation && (
            <ConfirmationPopup
              handleConfirmation={handleConfirmation}
              handleConfirmationClose={handleConfirmationClose}
              anyText="Do you want to remove item from this list?"
            />
          )}

          {showConfirmationDelete && (
            <Deletebutton
              handleRemove={handleRemove}
              Id={currentId}
              idType={currentIdType}
              handleConfirmationClose={handleConfirmationDeleteClose}
            />
          )}

          {popupVisible && (
            // Popup div
            <div className="popup">
              <div className="popup-content">
                <div className="note_popup">
                  <div className="note_popup_heading">
                    <div>
                      <h2>Notes</h2>
                    </div>
                    <div>
                      <button
                        className="note_popup_heading_close_btn"
                        onClick={() => {
                          setPopupVisible(false);
                          setShow1(!show1);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                  </div>
                  <div>
                    <p>{selectedNote}</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/*  download popup */}
          {popupVisibleDownlaod && (
            // Popup div

            <div className="popup">
              <div className="popup-content popup-content-download">
                <div className="note_popup">
                  <div className="note_popup_heading">
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <h2>Download Files</h2>
                    </div>
                    <div>
                      <button
                        className="note_popup_heading_close_btn"
                        onClick={() => {
                          setPopupVisibleDownlaod(false);
                          setShow(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                  </div>

                  <div>
                    <div style={{ marginBottom: "20px" }}>
                      <Tooltip title={selectedDownlaod.name}>
                        <div
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            gap: "20px",
                          }}
                          onClick={() => {
                            handleDownload(selectedDownlaod.name, 0);
                          }}
                        >
                          Downlaod - 1
                          <div className="myestate_download_button dwnbtn">
                            <FontAwesomeIcon
                              className="myestate_download_icon"
                              icon={faDownload}
                            />
                            <span>{selectedDownlaod.name}</span>
                          </div>
                        </div>
                      </Tooltip>
                    </div>

                    {selectedDownlaod.name1 && (
                      <div style={{ marginBottom: "20px" }}>
                        <Tooltip title={selectedDownlaod.name1}>
                          <div
                            //  value = {showDetail.user.id}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              gap: "20px",
                            }}
                            onClick={() => {
                              handleDownload(selectedDownlaod.name1, 1);
                            }}
                          >
                            Downlaod - 2
                            <div className="myestate_download_button dwnbtn">
                              <FontAwesomeIcon
                                className="myestate_download_icon"
                                icon={faDownload}
                              />
                              <span>{selectedDownlaod.name1}</span>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    )}

                    {selectedDownlaod.name2 && (
                      <div style={{ marginBottom: "20px" }}>
                        <Tooltip title={selectedDownlaod.name2}>
                          <div
                            //  value = {showDetail.user.id}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              gap: "20px",
                            }}
                            onClick={() => {
                              handleDownload(selectedDownlaod.name2, 2);
                            }}
                          >
                            Download - 3
                            <div className="myestate_download_button dwnbtn">
                              <FontAwesomeIcon
                                className="myestate_download_icon"
                                icon={faDownload}
                              />
                              <span>{selectedDownlaod.name2}</span>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    )}

                    {selectedDownlaod.name3 && (
                      <div style={{ marginBottom: "20px" }}>
                        <Tooltip title={selectedDownlaod.name3}>
                          <div
                            //  value = {showDetail.user.id}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              gap: "20px",
                            }}
                            onClick={() => {
                              handleDownload(selectedDownlaod.name3, 3);
                            }}
                          >
                            Download - 4
                            <div className="myestate_download_button dwnbtn">
                              <FontAwesomeIcon
                                className="myestate_download_icon"
                                icon={faDownload}
                              />
                              <span>{selectedDownlaod.name3}</span>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    )}

                    {selectedDownlaod.name4 && (
                      <div style={{ marginBottom: "20px" }}>
                        <Tooltip title={selectedDownlaod.name4}>
                          <div
                            //  value = {showDetail.user.id}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              gap: "20px",
                            }}
                            onClick={() => {
                              handleDownload(selectedDownlaod.name4, 4);
                            }}
                          >
                            Downlaod - 5
                            <div className="myestate_download_button dwnbtn">
                              <FontAwesomeIcon
                                className="myestate_download_icon"
                                icon={faDownload}
                              />
                              <span>{selectedDownlaod.name4}</span>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/*  beneficiary details popup */}
          {beneficiaryVisible && (
            <div className="popup">
              <div className="popup-content popup-content-download">
                <div className="note_popup">
                  <div className="note_popup_heading">
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <h2>share property</h2>
                    </div>
                    <div>
                      <button
                        className="note_popup_heading_close_btn"
                        onClick={() => {
                          setBeneficiaryVisible(false);
                          setShow1(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                  </div>
                  <div>
                    {selectedBeneficiary.sharedDetails &&
                      selectedBeneficiary.sharedDetails.map(
                        (details, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              margin: "5px",
                              padding: "10px",
                              border: "solid 1px lightgray",
                              borderRadius: "5px",
                              minWidth: "230px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "17px",
                                  color: "black",
                                  fontWeight: "500",
                                }}
                              >
                                Share - {index + 1}
                              </p>
                              {primaryUserDetails.accountType === "secondary" &&
                              secondaryUserDetails.accountType === "primary" &&
                              secondaryUserDetails.isSecondaryUserEditable ===
                                "false" ? (
                                ""
                              ) : (
                                // <Deletebutton
                                //   handleRemove={handleRemove}
                                //   Id={details.id}
                                //   idType="sharedDetailId"
                                // />
                                <FontAwesomeIcon
                                  onClick={() =>
                                    removeCrypto(details.id, "sharedDetailId")
                                  }
                                  className="delete-button-comp"
                                  style={{ cursor: "pointer" }}
                                  icon={faTrash}
                                />
                              )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                marginLeft: "20px",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "15px",
                                  color: "black",
                                  fontWeight: "400",
                                  marginLeft: "20px",
                                }}
                              >
                                Beneficiary Name:
                                <span style={{ marginLeft: "10px" }}>
                                  {getBenificiaryName(details.beneficiaryId)}
                                </span>
                              </p>
                              <p
                                style={{
                                  fontSize: "15px",
                                  color: "black",
                                  fontWeight: "400",
                                  marginLeft: "20px",
                                }}
                              >
                                Distributed Type:
                                <span style={{ marginLeft: "10px" }}>
                                  {details.distributedType}
                                </span>
                              </p>
                              <p
                                style={{
                                  fontSize: "15px",
                                  color: "black",
                                  fontWeight: "400",
                                  marginLeft: "20px",
                                }}
                              >
                                Distributed Value:{" "}
                                <span style={{ marginLeft: "10px" }}>
                                  {details &&
                                    details.distributedType === "dollar" &&
                                    "$"}
                                  {details.distributedValue}
                                  {details.distributedType === "percentage" &&
                                    "%"}
                                </span>
                              </p>
                              <p
                                style={{
                                  fontSize: "15px",
                                  color: "black",
                                  fontWeight: "400",
                                  marginLeft: "20px",
                                }}
                              >
                                Distributed Amount:
                                <span style={{ marginLeft: "10px" }}>
                                  {formatAmount(details.distributedAmount)}
                                </span>
                              </p>
                            </div>
                          </div>
                        )
                      )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/*  download popup */}
          {popupVisibleDownlaod && (
            <div className="popup">
              <div className="popup-content popup-content-download">
                <div className="note_popup">
                  <div className="note_popup_heading">
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <h2>Download Files</h2>
                    </div>
                    <div>
                      <button
                        className="note_popup_heading_close_btn"
                        onClick={() => {
                          setPopupVisibleDownlaod(false);
                          setShow1(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                  </div>
                  <div>
                    {selectedDownlaod.documents &&
                      selectedDownlaod.documents.length > 0 &&
                      selectedDownlaod.documents.map((file, index) => (
                        <div key={index} style={{ marginBottom: "20px" }}>
                          <Tooltip title={file.fileName}>
                            <div
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                gap: "20px",
                              }}
                              onClick={() => {
                                handleDownload(file.id, file.fileName);
                              }}
                            >
                              Download - {index + 1}
                              <div className="myestate_download_button dwnbtn">
                                <FontAwesomeIcon
                                  className="myestate_download_icon"
                                  icon={faDownload}
                                />
                                <span>{file.fileName}</span>
                              </div>
                            </div>
                          </Tooltip>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {benevisible && (
            <SharedBeneficiary
              assetName={"cryptoAssest"}
              handleTrustSave={handleTrustSave}
              assetIndexValue={assetIndexValue}
              assetData={cryptoAssetData[assetIndexValue]?.cryptoAssest}
              trusts={trusts}
              handleChanges={handleChanges}
              sharedType={sharedTypeArray[assetIndexValue]}
              handleCloseBeneficiaryPopup={handleCloseBeneficiaryPopup}
              estimatedTotalAmount={
                cryptoAssetData[assetIndexValue]?.cryptoAssest?.estValue
              }
              typeBeneficiary={"normal"}
              sharedDetails={cryptoAssetData[assetIndexValue]?.sharedDetails}
            />
          )}
        </SideBar>
      </UserBase>
    </div>
  );
}

export default Crypto;